import { BooleanInput } from '@angular/cdk/coercion';
import { I18nPluralPipe, NgTemplateOutlet } from '@angular/common';
import { booleanAttribute, Component, input } from '@angular/core';
import { provideIcons } from '@ng-icons/core';
import { lucideBadgeCheck, lucideBriefcase, lucideMapPin, lucideTicketCheck, lucideUsers } from '@ng-icons/lucide';
import { ChipComponent } from '@shared/components/chip/chip.component';
import { HlmIconImports } from '@spartan-ng/helm/icon';
import { ClassValue } from 'clsx';

import { Étape } from '../../référentiel-métier-parcours/models/étape.model';
import { ConvertIdReferentielToNomPipe } from '../pipes/convert-id-referentiel-to-nom.pipe';
import { ConvertTypesContratToStringPipe } from '../pipes/convert-type-contrat-to-string.pipe';
import { FiltrerParAnneePipe } from '../pipes/filtrer-par-annee.pipe';

@Component({
  selector: 'app-card-etape',
  imports: [
    HlmIconImports,
    ConvertTypesContratToStringPipe,
    ConvertIdReferentielToNomPipe,
    I18nPluralPipe,
    NgTemplateOutlet,
    FiltrerParAnneePipe,
    ChipComponent,
  ],
  templateUrl: './card-etape.component.html',
  providers: [
    provideIcons({
      lucideBriefcase,
      lucideBadgeCheck,
      lucideUsers,
      lucideMapPin,
      lucideTicketCheck,
    }),
  ],
})
export class CardEtapeComponent {
  readonly etape = input.required<Étape>();
  readonly showGroupes = input<boolean, BooleanInput>(false, { transform: booleanAttribute });
  readonly userClass = input<ClassValue>('', { alias: 'classes' });

  protected readonly groupeMapping: { [k: string]: string } = {
    '=0': '# groupe',
    '=1': '# groupe',
    other: '# groupes',
  };
}
